import * as React from 'react';
export var useSelectedOption = function useSelectedOption(params) {
  var value = params.value,
    groups = params.groups;
  var selectedOption = React.useMemo(function () {
    if (!value) {
      return null;
    }
    var option = null;
    groups.some(function (group) {
      option = group.options.find(function (option) {
        return option.value === value;
      }) || null;
      return !!option;
    });
    return option;
  }, [value, groups]);
  return selectedOption;
};